import { AsyncPipe, DatePipe, TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faBan, faBuildings, faUser } from '@fortawesome/pro-regular-svg-icons';
import { BaseUser, UserType, userTypeFromJSON } from '@enrollhere/classes';
import { TooltipComponent } from '../tooltip/tooltip.component';
import { UserCacheService } from '../../../services/user-cache.service';
import { AuthService } from '../../../services/auth.service';
import { userTypeMap } from '../../../data/userType';

@Component({
  selector: 'app-user-card',
  standalone: true,
  imports: [
    AsyncPipe,
    DatePipe,
    FaIconComponent,
    TitleCasePipe,
    TooltipComponent,
  ],
  templateUrl: './user-card.component.html',
  styleUrl: './user-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UserCardComponent implements OnInit {
  private authService = inject(AuthService);
  private cdr = inject(ChangeDetectorRef);
  userCacheService = inject(UserCacheService);

  @Input() small = false;
  @Input() xs = false;
  @Input() type: 'card' | 'text' = 'card';
  @Input() userId?: string;
  @Input() user?: BaseUser;
  @Input() userType?: UserType;
  @Input() showAgency = false;
  @Input() showUserType = false;

  now = new Date().getTime();

  faBan = faBan;
  faBuildings = faBuildings;
  faUser = faUser;

  userTypeMap = userTypeMap;
  userTypeFromJSON = userTypeFromJSON;

  user$ = this.authService.user$;
  UserType = UserType;

  ngOnInit() {
    if (this.userId && !this.userCacheService.cache[this.userId]) {
      this.userCacheService
        .addToCache(this.userId, this.user, this.user ? true : false)
        .then(() => this.cdr.detectChanges());
    }
  }
}
